'use strict';

module.exports = function isValidUserToken(userToken) {
  if (userToken === null) {
    return false;
  }
  return /^[a-zA-Z0-9_-]{1,64}$/.test(userToken);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/algoliasearch-helper/src/utils/isValidUserToken.js
// module id = 569
// module chunks = 1